export default __webpack_public_path__ + "static/media/herovid.cbd36c3b.mp4";